<section class="opportunity-grid">
    <app-client-side-grid
        #gridComponent
        [rowData]="rowData()"
        [columnDefs]="columnDefs()"
        [domLayout]="'autoHeight'"
        [autoSizeStrategy]="{ type: 'fitGridWidth', defaultMinWidth: 100 }"
        [suppressHorizontalScroll]="true"
        (cellValueChanged)="onCellValueChanged($event)"
    ></app-client-side-grid>
</section>
